import { Routes, Route } from "react-router-dom";
import App from "./App";
import Dashboard from "./pages/dashboard";
import Epidemic from "./pages/epidemic";
import EventSelection from "./pages/EventSelection";
import FoodSafety from "./pages/food-safety";
import FormLayout from "./pages/form-layout";
import HealthEvents from "./pages/health-events";
import Incidents from "./pages/Incidents";
import SafetyEvents from "./pages/Safety-events";
import SignIn from "./pages/SignIn";
import EventConfirm from "./pages/EventConfirm";
import SignInManager from "./pages/SignInManager";
import { ProtectedRoute } from "./protectedRoute";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import NothingToDeclare from "./pages/NothingToDeclare";

const router: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<App />}>
        <Route index element={<SignIn />} />
        <Route path="login-manager" element={<SignInManager />} />
      </Route>
      <Route
        path="confirm"
        element={
          <ProtectedRoute>
            <EventConfirm />
          </ProtectedRoute>
        }
      />
      <Route
        path="event-collect"
        element={
          <ProtectedRoute>
            <EventSelection />
          </ProtectedRoute>
        }
      />
      <Route
        path="forms"
        element={
          <ProtectedRoute>
            <FormLayout />
          </ProtectedRoute>
        }
      >
        <Route path="incidents" element={<Incidents />} />
        <Route path="safety-events" element={<SafetyEvents />} />
        <Route path="health-events" element={<HealthEvents />} />
        <Route path="epidemic" element={<Epidemic />} />
        <Route path="food-safety" element={<FoodSafety />} />
        <Route path="nothing-to-declare" element={<NothingToDeclare />} />
      </Route>
      <Route path="event-monitoring">
        <Route
          index
          element={
            <>
              <AuthenticatedTemplate>
                <Dashboard />
              </AuthenticatedTemplate>
              <UnauthenticatedTemplate>
                <SignInManager />
              </UnauthenticatedTemplate>
            </>
          }
        />
        <Route
          path=":reportingId"
          element={
            <>
              <AuthenticatedTemplate>
                <Dashboard />
              </AuthenticatedTemplate>
              <UnauthenticatedTemplate>
                <SignInManager />
              </UnauthenticatedTemplate>
            </>
          }
        />
      </Route>
    </Routes>
  );
};

export default router;
